<template>
<div class="container3 d-flex mx-auto" align="center">

<h1 > <p class="border-bottom my-3">
  404</p>Page not found</h1>
    </div>
</template>

<script>

export default {
  name: 'NotFound',
  methods: {
    clear () {
      this.$store.dispatch('clearStore')
    }
  },
  created () {
    this.clear()
  },
  watch: {
    $route: function (newrot, oldrot) {
      console.log(oldrot, 'redirect -->', newrot)
      this.route.push(newrot)
    }
  }

}
</script>
